export default "assets/images/ARDOISE_SD-a320178e.jpg";